import React from 'react';

// Include Redux
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers';

const Redux = ({ children, initialState = {} }) => {
  return (
    <Provider
      store={createStore(reducers, initialState, applyMiddleware(thunk))}
    >
      {children}
    </Provider>
  );
};

export default Redux;
